import Controller from "./commuterPackage.controller";
import template from "./commuterPackage.html";

const commuterPackage = {
  template,
  controller: Controller,
};

export default commuterPackage;



// WEBPACK FOOTER //
// ./src/pages/commuterPackage/commuterPackage.component.js